import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import Logo from "./Logo";

const NAV_ITEMS = [
  { to: "/features", label: "Features" },
  { to: "/solutions", label: "Solutions" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/75 border-b border-[#E2E8F0]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="container-secqre flex h-16 md:h-20 items-center justify-between">
        <Logo size="md" />

        <nav className="hidden lg:flex items-center gap-1" data-testid="navbar-links">
          {NAV_ITEMS.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={`nav-link-${it.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-3.5 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive ? "text-[#0A0A0A] bg-[#F8F9FA]" : "text-[#475569] hover:text-[#0A0A0A]"
                }`
              }
            >
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/pricing" className="text-sm font-medium text-[#475569] hover:text-[#0A0A0A]" data-testid="navbar-pricing-link">
            See plans
          </Link>
          <Link to="/contact" className="btn-primary !py-2.5 !px-5 text-sm" data-testid="navbar-cta">
            Get SECQRE <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md border border-[#E2E8F0] bg-white"
          aria-label="Toggle menu"
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E2E8F0] bg-white" data-testid="navbar-mobile-menu">
          <div className="container-secqre py-4 flex flex-col gap-1">
            {NAV_ITEMS.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-base font-medium ${
                    isActive ? "bg-[#F8F9FA] text-[#0A0A0A]" : "text-[#475569]"
                  }`
                }
                data-testid={`nav-mobile-link-${it.label.toLowerCase()}`}
              >
                {it.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn-primary mt-2" onClick={() => setOpen(false)} data-testid="navbar-mobile-cta">
              Get SECQRE <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
